import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Box } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import AppsIcon from "@mui/icons-material/Apps";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        padding: "0px",
        margin: "0px",
        height: "100%",
        backgroundColor: "#111111",
        color: "white",
        borderTopRightRadius: "100px",
        boxSizing: "border-box",
        position: "relative",
        display: "flex",
    },
    sidebarTop: {},
    sidebarBottom: {
        position: "absolute",
        bottom: "0px",
        width: "100%",
    },
    divider: {
        border: "0px solid #74767C",
        width: "81%",
        margin: "0px auto",
        backgroundColor: "#74767C",
        height: "0.1px",
        color: "#74767C",
    },
    info: {
        color: "#fff",
        padding: "10px",
        marginLeft: "10px",
    },
    infoItems: {},
    adminBox: {
        padding: "10px",
        marginLeft: "20px",
        fontSize: "20px",
    },
    buttons: {
        textDecoration: "none",
        color: "#fff",
        padding: "10px",
        borderRadius: "20px",
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            background: "#222",
        },
    },
    dashboardBtns: {
        marginTop: "150px",
        paddingLeft: "20px",
        fontSize: "20px",
    },
    fixBtn: {
        display: "flex",
    },
    text: {
        marginLeft: "10px",
    },
    links: {
        textDecoration: "none",
    },
});

const Sidebar = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container className={classes.root}>
                <Grid item xs={12}>
                    <Box className={classes.sidebarTop}>
                        <Box className={classes.dashboardBtns}>
                            <Link to="/dashboard" className={classes.links}>
                                <Box className={classes.buttons}>
                                    <Box className={classes.fixBtn}>
                                        <DesktopWindowsIcon />
                                        <span className={classes.text}>
                                            Machine
                                        </span>
                                    </Box>
                                </Box>
                            </Link>
                            <Link to="/apps" className={classes.links}>
                                <Box className={classes.buttons}>
                                    <Box className={classes.fixBtn}>
                                        <AppsIcon />
                                        <span className={classes.text}>
                                            Applications
                                        </span>
                                    </Box>
                                </Box>
                            </Link>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} className={classes.sidebarBottom}>
                    <Box className={classes.divider}></Box>
                    <Box className={classes.info}>
                        <Box className={classes.adminBox}>Admin 1.1.1.1</Box>
                        <Box className={classes.infoItems}>
                            <Box className={classes.buttons}>
                                <Box className={classes.fixBtn}>
                                    <SettingsIcon />
                                    <span className={classes.text}>
                                        Settings
                                    </span>
                                </Box>
                            </Box>
                        </Box>
                        <Box className={classes.infoItems}>
                            <Box className={classes.buttons}>
                                <Box className={classes.fixBtn}>
                                    <LogoutIcon />
                                    <span className={classes.text}>Exit</span>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default Sidebar;
